import { QueryClient, QueryFunctionContext, useInfiniteQuery, useQuery, useQueryClient } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import {
  ShipmentOrderLegRunForPlanEntity,
  ShipmentOrderLegRunListResponse,
} from 'src/entities/ShipmentOrderLegRun.entity';

export const SHIPMENT_ORDER_LEG_RUNS_QUERY_KEY = 'shipment-order-leg-runs';

const fetchShipmentOrderLegRuns = (queryClient: QueryClient) => async ({ pageParam = 1, queryKey }: QueryFunctionContext) => {
  const startOn = queryKey[1] as string;
  const endOn = queryKey[2] as string;
  const perPage = queryKey[3] as number;

  const response: AxiosResponse<ShipmentOrderLegRunListResponse> = await axios.get(
    `/api/v5/shipment_order_leg_runs?start_on=${startOn}&end_on=${endOn}&page=${pageParam}&per_page=${perPage}`
  );

  response.data.data.forEach((entity) => {
    queryClient.setQueryData([SHIPMENT_ORDER_LEG_RUNS_QUERY_KEY, { id: entity.id }], entity);
  });

  return response.data;
};

const fetchShipmentOrderLegRun = (id: number) => async () => {
  const response: AxiosResponse<ShipmentOrderLegRunForPlanEntity> = await axios.get(`/api/v5/shipment_order_leg_runs/${id}`);
  return response.data;
};

export const useInfiniteQueryShipmentOrderLegRuns = (startOn: string, endOn: string, perPage: number) => {
  const queryClient = useQueryClient();

  return useInfiniteQuery(
    [SHIPMENT_ORDER_LEG_RUNS_QUERY_KEY, startOn, endOn, perPage],
    fetchShipmentOrderLegRuns(queryClient),
    {
      enabled: Boolean(startOn) && Boolean(endOn),
      staleTime: Infinity,
      getNextPageParam: (lastPage, allPages) => (
        allPages.length < lastPage.total_pages_count ? allPages.length + 1 : undefined
      ),
    }
  );
};

export const useQueryShipmentOrderLegRun = (id: number) => useQuery(
  [SHIPMENT_ORDER_LEG_RUNS_QUERY_KEY, { id }],
  fetchShipmentOrderLegRun(id),
  {
    enabled: Boolean(id),
    staleTime: Infinity,
  }
);
